export default "__VITE_ASSET__BJEyPGoi__"